export default __webpack_public_path__ + "static/media/783.b67b8c9c.png";